<mat-dialog-content>
  <span class="uk-text-subheading" *ngIf="description.superTitle">{{ description.superTitle }}</span>
  <mat-icon [color]="description.color" *ngIf="description.icon">{{
    description.icon
  }}</mat-icon>
  <mat-icon
    class="icon-load"
    [ngClass]="description.iconSVG"
    [svgIcon]="description.iconSVG"
    *ngIf="description.iconSVG"
  ></mat-icon>
  <span class="title" [innerHTML]="description.title"></span>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button
    *ngIf="
      description.typeModal != 'invalid' && description.typeModal != 'accept'
    "
    mat-button
    id="cancel"
    class="b-s"
    (click)="onClickClose()"
    class="m-2 button-cancel"
    type="button"
  >
    {{
      description?.valueCancelButton
        ? description.valueCancelButton
        : buttonSecond
    }}
  </button>
  <button
    id="exit2"
    *ngIf="
      description.typeModal === 'notification' ||
      description.typeModal === 'invalid' ||
      description.typeModal === 'accept'
    "
    mat-flat-button
    [color]="description.color"
    class="button-primary-event m-2 description.color"
    [ngClass]="classButton"
    [mat-dialog-close]="description.typeModal"
  >
    {{ description.valueButton }}
  </button>
</mat-dialog-actions>
<button id="closeAddAddress" mat-button mat-dialog-close class="dialog-close">
  <mat-icon>close</mat-icon>
</button>
